import { Role, roleNameDictionary } from '@models/Role'
import { useAppSelector } from '@store/hooks'
import { selectRoleById } from '@store/RoleReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Tag } from 'antd'
import { FC } from 'react'

type Props = SBModelComponent<Role> & {}

export const RoleTag: FC<Props> = ({ id, model }) => {
  const item = model ? model : useAppSelector(selectRoleById(id!))

  if (!item) {
    return <></>
  }

  return <Tag>{roleNameDictionary[item.name]}</Tag>
}

export type RoleTagType = { Tag: typeof RoleTag }
